
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auction",
      function () {
        return require("private-next-pages/auction.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auction"])
      });
    }
  